export default __webpack_public_path__ + "static/media/abraham-lincoln.a1367ecb.png";